// removed by extract-text-webpack-plugin
module.exports = {"notFound":"styles__notFound__2N34n","fourOhFour":"styles__fourOhFour__3Iw8s"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/NotFound/styles.scss
// module id = 425
// module chunks = 0